import { SpeakerCard } from '../../cards';
import { ContentList } from '../../ContentList';

import { selectSiteDiscoverySpeakerRecord } from '../../../../../../store/features/discovery';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import { UseInfiniteScrollProps } from '../../../../../../hooks';

export interface SpeakerListProps {
  loadMoreResults: UseInfiniteScrollProps['fetchMoreData'];
  enableLoadingByScroll: boolean;
}

export function SpeakerList(props: SpeakerListProps) {
  const { loadMoreResults, enableLoadingByScroll } = props;
  const { results, totalPages } = useRootSelector((state) =>
    selectSiteDiscoverySpeakerRecord(state),
  );
  const { siteType } = useRootSelector(selectPageConfig);

  return (
    <ContentList
      items={results}
      totalPage={totalPages}
      onLoadMore={loadMoreResults}
      enableLoadingByScroll={enableLoadingByScroll}
    >
      {(item) => <SpeakerCard data={item} siteType={siteType} />}
    </ContentList>
  );
}
